import styled from 'styled-components';
import { PrimaryButton } from 'components';

export const FilterLabel = styled.label`
  display: flex;
  cursor: pointer;
  padding: 5px;
`;

export const FilterCheckbox = styled.input`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;

  &:checked ~ span {
    background-color: #000;

    svg {
      display: block;
    }
  }

  ~ span {
    border-radius: 2px;
    border: 1px solid #000;
    height: 18px;
    width: 18px;
    margin-top: 5px;
    margin-right: 5px;
  }
`;

export const FilterOption = styled.div`
  font-size: 18px;
  line-height: 18px;
  font-weight: 300;
  margin: 0;
  margin-left: 5px;
`;

export const FilterOptionWrapper = styled.div`
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const FilterButton = styled(PrimaryButton)`
  border-radius: 500px;
  width: 100%;
  padding-left: 2rem;
  padding-right: 2rem;

  ${props =>
    props.disabled &&
    `
    cursor: initial;
  `}
`;

export const FiltersModalBody = styled.div`
  margin-right: 0;
  margin-left: 0;
  max-width: 100%;
  padding: 0 2rem;
  height: 100%;
`;

export const FiltersModalFooter = styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
  width: 100%;
  position: fixed;
  bottom: 0;
  padding: 1rem;
  background-color: white;

  &.mobile {
    bottom: -1rem;
    padding: 1rem 3rem 1rem 0;
  }
`;
